module.exports = __webpack_public_path__ + "static/media/CSVMedewerkerExampleWithLanguage.09788dd1.csv";